export default "/images/vendor/flag-icons/flags/4x3/tg.svg?ae395581590b44c50c4019a8e8ba55fc";